import {Component, EventEmitter, Input, OnInit, Output, AfterViewInit} from '@angular/core';
import {OrganizationData} from '../../api/user-info-model';
import {FilterStorageService} from '../../services/filter-storage.service';
import * as moment from 'moment';
import {DashboardService} from '../../api/dashboard.service';

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss']
})
export class DashboardFiltersComponent implements OnInit, AfterViewInit {
  @Output()
  filtersChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  hideDatePicker = true;

  organizations: OrganizationData[] = [];
  selectedOrganization: OrganizationData = null;
  start: Date;
  end: Date;
  dateRanges: Array<{ label: string, start: Date, end: Date }>;
  private initialized = false;

  constructor(private filterStorage: FilterStorageService,
              private dashboardService: DashboardService) { }

  async ngOnInit() {
    this.initRanges();

    try{
      const organizations = await this.dashboardService.getOrganizations().toPromise();
      this.organizations = organizations.organizations;

      const selectedOrganization = this.tryToFindSelectedOrganization(this.organizations);
      if (selectedOrganization == null) {
        this.changeLocation(organizations.defaultOrganizationId);
      } else {
        this.selectedOrganization = selectedOrganization;
      }

      const selectedRange = this.filterStorage.getSelectedRange();
      this.start = selectedRange.start;
      this.end = selectedRange.end;
    } catch (e) {
      alert("Try ro refresh the page: " + e.error.message);
      console.error(e);
    }
  }

  tryToFindSelectedOrganization(organizationList: OrganizationData[]) {
    const organization = this.filterStorage.getSelectedOrganization();

    if (organization == null) { return null; }

    if (organizationList.filter(o => o.id === organization.id).length > 0) {
      return organization;
    }

    return null;
  }

  changeLocation(organizationId: string) {
    const organization = this.organizations.filter(o => {
      return o.id === organizationId;
    })[0];

    this.filterStorage.saveSelectedOrganization(organization.id, organization.name);
    this.selectedOrganization = organization;

    this.emitEvent();
  }

  private initRanges() {
    this.dateRanges =
      [
        {label: 'Last 7 Days', start: moment().subtract(6, 'days').toDate(), end: moment().toDate()},
        // tslint:disable-next-line:max-line-length
        {label: 'Last Week', start: moment().subtract(1, 'week').startOf('week').toDate(), end: moment().subtract(1, 'week').endOf('week').toDate() },
        {label: 'Week To Date', start: moment().startOf('week').toDate(), end: moment().toDate()},
        {label: 'This Month', start: moment().startOf('month').toDate(), end: moment().endOf('month').toDate()},
        // tslint:disable-next-line:max-line-length
        {label: 'Last Month', start: moment().subtract(1, 'month').startOf('month').toDate(), end: moment().subtract(1, 'month').endOf('month').toDate() },
        {label: 'Quarter To Date', start: moment().startOf('quarter').toDate(), end: moment().endOf('quarter').toDate()},
        {label: 'Year To Date', start: moment().startOf('year').toDate(), end: moment().endOf('year').toDate()}
    ];
  }

  rangeChanged($event: any) {
    this.filterStorage.saveSelectedRange(this.start, this.end);
    this.emitEvent();
  }

  private emitEvent() {
    if (!this.initialized) { return; }

    this.filtersChanged.emit(true);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initialized = true;
    }, 200);
  }
}
